/* eslint-disable no-console */
import { context, trace } from '@opentelemetry/api';
import axios from 'axios';
import { nanoid } from 'nanoid';

import { getFrontApiBase } from '../helpers/http';
import logger from '../helpers/logger';

const requestInstance = axios.create({
  baseURL: getFrontApiBase() || '/',
  headers: {
    post: { 'Content-Type': 'application/json' },
  },
});

requestInstance.interceptors.request.use(
  (config) => {
    const { headers, baseURL, url, method, params, data } = config;
    const { domain = {} } = process;
    const xReqId = nanoid();
    headers['x-request-id'] = headers?.requestid || domain?.id || xReqId; // 如果 domain.id 不存在，则随机生成一个
    let traceID = '';
    if (typeof window !== 'object') {
      const span = trace.getSpan(context.active());
      // 从Span中获取traceId
      if (span) {
        traceID = span.spanContext().traceId;
        span.setAttribute('req.data', JSON.stringify(data));
        span.setAttribute('req.params', JSON.stringify(params));
        span.setAttribute('req.headers', JSON.stringify(headers));
        span.setAttribute('req.url', url);
        span.setAttribute('req.method', method);
        span.setAttribute('req.baseURL', baseURL);
      }
    }
    logger.info('requestInstance-request', { headers, baseURL, url, method, params, data, iTraceId: traceID });
    return config;
  },
  (error) => Promise.reject(error),
);

requestInstance.interceptors.response.use(
  (response) => {
    if (response?.status === 200) {
      const {
        config: { headers, baseURL, url, method, params, data },
      } = response;
      let traceID = '';
      if (typeof window !== 'object') {
        const span = trace.getSpan(context.active());
        // 从Span中获取traceId
        if (span) {
          traceID = span.spanContext().traceId;
        }
      }
      logger.info('requestInstance-response', {
        headers,
        baseURL,
        url,
        method,
        params,
        data,
        resCode: response?.data?.code,
        iTraceId: traceID,
      });
      return response?.data;
    }
    return Promise.reject(response?.data);
  },
  (error) => Promise.reject(error),
);

export default requestInstance;
